/**
 * This is a map of ids to node details, which is used when mapping markdown back to pm.
 */

/** A context from analytics. */

/**
 * type guard to detect if the initial context is for range selection
 * based on selection prop availability
 */
export function isInitialContextSelectionRange(
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
  return 'selection' in value && typeof value.selection === 'string';
}

/**
 * `EditorPluginAIConfigItem`s are used by EditorPluginAI to provide AI experiences.
 */

export function isEditorPluginAIConfigItemWithOptions(item) {
  return !!item;
}
export function canShowEditorPluginAIConfigItem(_ref) {
  var _emptyOptions$docMinS, _emptyOptions$docMaxS, _selectionOptions$sel, _selectionOptions$sel2;
  var editorView = _ref.editorView,
    positions = _ref.positions,
    isEmpty = _ref.isEmpty,
    item = _ref.item;
  var triggers = item.triggers;
  var doc = editorView.state.doc;
  // Size of the doc with a single empty paragraph is 4
  var docSize = doc.nodeSize - 4;
  var selectionSize = positions[1] - positions[0];
  if (triggers.canShow && !triggers.canShow({
    editorView: editorView,
    docSize: docSize,
    selectionSize: selectionSize
  })) {
    return false;
  }
  var emptyOptions = triggers.empty;
  var emptyEnabled = emptyOptions.enabled;
  var docMinSize = (_emptyOptions$docMinS = emptyOptions.docMinSize) !== null && _emptyOptions$docMinS !== void 0 ? _emptyOptions$docMinS : 0;
  var docMaxSize = (_emptyOptions$docMaxS = emptyOptions.docMaxSize) !== null && _emptyOptions$docMaxS !== void 0 ? _emptyOptions$docMaxS : Number.MAX_SAFE_INTEGER;
  var selectionOptions = triggers.selection;
  var selectionEnabled = selectionOptions.enabled;
  var selectionMinSize = (_selectionOptions$sel = selectionOptions.selectionMinSize) !== null && _selectionOptions$sel !== void 0 ? _selectionOptions$sel : 1;
  var selectionMaxSize = (_selectionOptions$sel2 = selectionOptions.selectionMaxSize) !== null && _selectionOptions$sel2 !== void 0 ? _selectionOptions$sel2 : Number.MAX_SAFE_INTEGER;
  if (isEmpty) {
    if (!emptyEnabled || docSize < docMinSize || docSize > docMaxSize) {
      return false;
    }
  } else {
    if (!selectionEnabled || selectionSize < selectionMinSize || selectionSize > selectionMaxSize) {
      return false;
    }
  }
  return true;
}
export function getEditorPluginAIConfigItemActions(_ref2) {
  var _ref3;
  var isEmpty = _ref2.isEmpty,
    configItem = _ref2.configItem;
  if (!configItem) {
    return [];
  }
  var actions = (_ref3 = isEmpty ? configItem.actions.empty : configItem.actions.selection) !== null && _ref3 !== void 0 ? _ref3 : [];
  return actions;
}
export function getVisibleEditorPluginAIConfigItems(_ref4) {
  var configItemWithOptions = _ref4.configItemWithOptions,
    editorView = _ref4.editorView,
    positions = _ref4.positions,
    isEmpty = _ref4.isEmpty;
  var arr = [];
  configItemWithOptions.forEach(function (item) {
    if (!item) {
      return;
    }
    if (canShowEditorPluginAIConfigItem({
      editorView: editorView,
      positions: positions,
      isEmpty: isEmpty,
      item: item
    })) {
      arr.push(item.config);
    }
  });
  return arr;
}

/**
 * This function is used to get all the config items from the configItems array without checking if they can be shown
 */
export function getAllEditorPluginAIConfigItems(_ref5) {
  var configItemWithOptions = _ref5.configItemWithOptions;
  var arr = [];
  configItemWithOptions.forEach(function (item) {
    if (!item) {
      return;
    }
    arr.push(item.config);
  });
  return arr;
}
export function getTranslatedItemTitle(configItem, formatMessage) {
  // for agents return the saved agent name in the same language as it was saved
  if (configItem.agent) {
    var presetTitle = "@".concat(configItem.agent.name);
    return presetTitle || formatMessage(configItem.title);
  }

  // adding beta label for the translation prompts
  if (configItem.key.startsWith('Translate to')) {
    return formatMessage(configItem.title);
  }

  // for all other items return the i18n-ed title
  return formatMessage(configItem.title);
}

/**
 * use this function get the translated prompt label in the ui components
 */
export function getTranslatedPromptLabel(configItem, formatMessage) {
  if (configItem.agent) {
    // for agents return the saved agent name in the same language as it was saved
    return "@".concat(configItem.agent.name);
  }

  // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
  return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}